// import { useEffect, useRef, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
// } from "@mui/material";
// import IsoDateInput from "../common/Isodateinput";
// import SearchableSelect from "../common/SearchableSelect";
// import toIsoDate from "../../utils/dateFormat";

// const PRIMARY = "#1B5C20";

// const loanTypes = [
//   { value: "Personal", label: "Personal" },
//   { value: "Housing", label: "Housing" },
//   { value: "Vehicle", label: "Vehicle" },
//   { value: "Emergency", label: "Emergency" },
//   { value: "Education", label: "Education" },
//   { value: "Other", label: "Other" },
// ];

// const initialForm = {
//   employeeId: "",
//   loanNo: "",
//   loanType: "",
//   dueDate: "",
//   loanDescription: "",
//   // loanDate: new Date().toISOString().split("T")[0],
//   loanDate: null,
//   loanAmount: "",
//   interestRate: "",
//   totalInterest: "",
//   totalAmount: "",
//   noOfInstallments: "",
//   installmentAmount: "",
//   startPeriodId: "",
//   balanceAmount: "",
//   status: "P",
//   remarks: "",
// };

// const inputClass = `
//   w-full h-14
//   rounded-md
//   border border-surface-200
//   bg-white
//   px-3.5
//   text-[16px] text-surface-800
//   outline-none
//   transition-colors
//   focus:border-primary-500
//   focus:ring-1 focus:ring-primary-500
// `;

// const labelClass = `
//   absolute
//   left-3
//   top-0
//   -translate-y-1/2
//   bg-white
//   px-1.5
//   text-[13px]
//   text-surface-500
//   pointer-events-none
//   z-10
// `;

// const errorClass = "!border-red-400 focus:!border-red-500 focus:!ring-red-500";

// const maskCurrencyInput = (rawValue) => {
//   const digits = String(rawValue ?? "").replace(/\D/g, "");

//   if (!digits) return "";

//   const padded = digits.padStart(3, "0");
//   const cents = padded.slice(-2);

//   const wholeDigits = padded.slice(0, -2).replace(/^0+(?=\d)/, "");
//   const whole = Number(wholeDigits || "0").toLocaleString("en-US");

//   return `${whole}.${cents}`;
// };

// const parseCurrency = (value) => {
//   if (value === "" || value === null || value === undefined) return 0;
//   const n = Number(String(value).replace(/,/g, ""));
//   return Number.isNaN(n) ? 0 : n;
// };

// function Field({ label, children, error = ""}) {
//   return (
//     <div className="relative">
//       <label className={labelClass}>
//         {label}
//       </label>

//       {children}

//       {error && (
//         <p className="mt-1.5 flex items-start gap-1 text-xs text-red-600">
//           {error}
//         </p>
//       )}
//     </div>
//   );
// }

// function TextInput({
//   label,
//   value,
//   onChange,
//   type = "text",
//   disabled = false,
//   readOnly = false,
//   helperText,
//   helperError = false,
//   error = "",
// }) {
//   return (
//     <div>
//       <Field label={label} error={error}>
//         <input
//           type={type}
//           value={value}
//           onChange={onChange}
//           disabled={disabled}
//           readOnly={readOnly}
//           className={`
//             ${inputClass}
//             ${readOnly ? "bg-surface-50" : ""}
//             ${disabled
//               ? "cursor-not-allowed bg-surface-50 text-surface-400"
//               : ""}
//             ${
//               error ? errorClass : ""
//             }
//           `}
//         />
//       </Field>

//       {helperText && (
//         <p
//           className={`
//             mt-1 px-1 text-[12px]
//             ${helperError ? "text-[#C0392B]" : "text-surface-500"}
//           `}
//         >
//           {helperText}
//         </p>
//       )}
//     </div>
//   );
// }

// function DateInput({ label, value, onChange, error = "" }) {
//   return (
//     <Field label={label} error={error}>
//       <IsoDateInput
//         value={value}
//         onChange={(valueOrEvent) => {
//           const value =
//             valueOrEvent?.target !== undefined
//               ? valueOrEvent.target.value
//               : valueOrEvent;

//           onChange({
//             target: {
//               value,
//             },
//           });
//         }}
//         className={`${inputClass} appearance-none ${
//           error ? errorClass : ""
//         }`}
//       />
//     </Field>
//   );
// }

// function TextAreaInput({
//   label,
//   value,
//   onChange,
//   rows = 2,
//   error = ""
// }) {
//   return (
//     <Field label={label} error={error}>
//       <textarea
//         value={value}
//         onChange={onChange}
//         rows={rows}
//         className={`
//           w-full
//           rounded-md
//           border border-surface-200
//           bg-white
//           px-3.5
//           py-3
//           text-[16px]
//           text-surface-800
//           outline-none
//           transition-colors
//           focus:border-primary-500
//           focus:ring-1
//           focus:ring-primary-500
//           ${error ? errorClass : ""}
//         `}
//       />
//     </Field>
//   );
// }

// function CurrencyInput({
//   label,
//   value,
//   onChange,
//   disabled = false,
//   readOnly = false,
//   helperText,
//   error = "",
// }) {
//   // If the field is read-only (calculated), we receive a raw number and format it.
//   // If the field is editable, the value is already masked via state.
//   let displayValue = value ?? "";
//   if (readOnly && displayValue !== "") {
//     const num = Number(displayValue);
//     if (!Number.isNaN(num)) {
//       displayValue = num.toLocaleString("en-US", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       });
//     }
//   }

//   const handleChange = (e) => {
//     if (!readOnly && onChange) {
//       const masked = maskCurrencyInput(e.target.value);
//       onChange({
//         target: {
//           value: masked,
//         },
//       });
//     }
//   };

//   return (
//     <div>
//       <Field label={label} error={error}>
//         <input
//           type="text"
//           inputMode="numeric"
//           value={displayValue}
//           onChange={handleChange}
//           disabled={disabled}
//           readOnly={readOnly}
//           className={`
//             ${inputClass}
//             ${readOnly ? "bg-surface-50" : ""}
//             ${
//               disabled
//                 ? "cursor-not-allowed bg-surface-50 text-surface-400"
//                 : ""
//             }
//             ${error ? errorClass : ""}
//           `}
//         />
//       </Field>

//       {helperText && (
//         <p className="mt-1 px-1 text-[12px] text-surface-500">
//           {helperText}
//         </p>
//       )}
//     </div>
//   );
// }

// export default function AddLoanDialog({
//   open,
//   onClose,
//   onSave,
//   loading,
//   employees = [],
//   payrollPeriods = [],
//   initialData,
//   nextLoanNo = "",
// }) {
//   const [form, setForm] = useState(initialForm);
//   const [errors, setErrors] = useState({});

//   // The loan as it was when Edit opened — used to keep the outstanding balance
//   // right when the loan amount is changed (see the totals effect below).
//   const original = useRef({ amount: 0, balance: 0 });

//   const toBool = (v) => v === true || v === 1 || String(v).toLowerCase() === "true" || String(v) === "1";

//   useEffect(() => {
//     if (!open) return;
//     setErrors({});

//     if (initialData) {
//       const activeState = toBool(initialData.isActive)

//       setForm({
//         id: initialData.id,
//         employeeId: initialData.employeeId || "",
//         loanNo: initialData.loanNo || "",
//         loanType: initialData.loanType || "",
//         loanDescription: initialData.loanDescription || "",
//         loanDate: initialData.loanDate ? toIsoDate(initialData.loanDate) : "",
//         loanAmount: initialData.amount != null 
//           ? maskCurrencyInput(String(Math.round(Number(initialData.amount) * 100))) 
//           : "",
//         interestRate: initialData.interestRate ?? "",
//         totalInterest: initialData.totalInterest ?? "",
//         totalAmount: initialData.totalAmount ?? "",
//         noOfInstallments: initialData.installments ?? "",
//         installmentAmount: initialData.installmentAmount ?? "",
//         startPeriodId: initialData.startPeriodId || "",
//         balanceAmount: initialData.balance ?? "",
//         // status: initialData.status || "P",
//         remarks: initialData.remarks || "",

//         // Kept as-is on update so saving doesn't wipe or change them.
//         approvedBy: initialData.approvedBy || "",
//         approvedDate: initialData.approvedDate || "",
//         status: initialData.statusCode || (initialData.status === "Not Paid" ? "P" : initialData.status) || "P",
//         isActive: activeState,
//       });
//       original.current = {
//         amount: Number(initialData.amount || 0),
//         balance: Number(initialData.balance ?? initialData.amount ?? 0),
//       };
//     } else {
//       setForm({
//         ...initialForm,
//       });
//     }
//   }, [open, initialData]);

//   // --- OLD CALCULATION LOGIC ------------
//   // Recalculate loan totals whenever the amount,
//   // interest rate, or installment count changes.
//   // useEffect(() => {
//   //   const amount = parseCurrency(form.loanAmount);
//   //   const rate = Number(form.interestRate || 0);
//   //   const installments = Number(form.noOfInstallments || 0);

//   //   const totalInterest =
//   //     Math.round(((amount * rate) / 100) * 100) / 100;

//   //   const totalAmount =
//   //     Math.round((amount + totalInterest) * 100) / 100;

//   //   const installmentAmount =
//   //     installments > 0
//   //       ? Math.round((totalAmount / installments) * 100) / 100
//   //       : "";

//   //   // New loan: nothing repaid yet, so balance = amount.
//   //   // Edit: keep what has already been repaid — move the balance by the same
//   //   // amount the loan amount changed (never below 0).
//   //   const balanceAmount = initialData
//   //     ? Math.max(0, Math.round((original.current.balance + (amount - original.current.amount)) * 100) / 100)
//   //     : amount;

//   //   setForm((prev) => ({
//   //     ...prev,
//   //     totalInterest,
//   //     totalAmount,
//   //     installmentAmount,
//   //     balanceAmount,
//   //   }));

//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [
//   //   form.loanAmount,
//   //   form.interestRate,
//   //   form.noOfInstallments,
//   // ]);

//   // --- NEW CALCULATION LOGIC -----------------
//   useEffect(() => {
//     const amount = parseCurrency(form.loanAmount);
//     const rate = Number(form.interestRate || 0);
//     const installments = Number(form.noOfInstallments || 0);

//     if (amount <= 0 || installments <= 0) {
//       setForm((prev) => ({
//         ...prev,
//         totalInterest: 0,
//         totalAmount: amount,
//         installmentAmount: "",
//         balanceAmount: amount,
//       }));
//       return;
//     }

//     const monthlyRate = rate / 12 / 100;

//     let installmentAmount = 0;

//     if (monthlyRate === 0) {
//       installmentAmount = Math.round((amount / installments) * 100) / 100;
//     } else {
//       // Standard Reducing Balance EMI Formula: [P * r * (1 + r)^n] / [(1 + r)^n - 1]
//       const factor = Math.pow(1 + monthlyRate, installments);
//       const emi = (amount * monthlyRate * factor) / (factor - 1);
//       installmentAmount = Math.round(emi * 100) / 100;
//     }

//     const totalAmount = Math.round(installmentAmount * installments * 100) / 100;
//     const totalInterest = Math.max(0, Math.round((totalAmount - amount) * 100) / 100);

//     const balanceAmount = initialData ? Math.max(0, Math.round((original.current.balance + (amount - original.current.amount)) * 100) / 100) : amount;

//     setForm((prev) => ({
//       ...prev,
//       totalInterest,
//       totalAmount,
//       installmentAmount,
//       balanceAmount,
//     }));
//   }, [
//     form.loanAmount,
//     form.interestRate,
//     form.noOfInstallments
//   ]);

//   const handleChange = (field) => (e) => {
//     setForm((prev) => ({
//       ...prev,
//       [field]: e.target.value,
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       [field]: ""
//     }))
//   };

//   const validate = () => {
//     const newErrors = {};

//     if (!form.employeeId) {
//       newErrors.employeeId = "Employee is required.";
//     }

//     if (!form.loanType) {
//       newErrors.loanType = "Loan type is required.";
//     }

//     const amount = parseCurrency(form.loanAmount);

//     if (!form.loanAmount || amount <= 0) {
//       newErrors.loanAmount = "Loan amount must be greater than 0.";
//     }

//     const rate = Number(form.interestRate);

//     if (form.interestRate === "" || Number.isNaN(rate) || rate <= 0) {
//       newErrors.interestRate = "Interest rate must be greater than 0.";
//     } else if (rate > 100) {
//       newErrors.interestRate = "Interest rate cannot be above 100.";
//     }

//     const installments = Number(form.noOfInstallments);

//     if (form.noOfInstallments === "" || Number.isNaN(installments) || installments <= 0) {
//       newErrors.noOfInstallments = "Number of installments must be greater than 0.";
//     }

//     if (!form.startPeriodId) {
//       newErrors.startPeriodId = "Payroll period is required.";
//     }

//     // The first due date only creates the installment schedule for a new loan;
//     // the field isn't shown when editing, so it isn't required there.
//     if (!initialData && !form.dueDate) {
//       newErrors.dueDate = "Installment due date is required.";
//     }

//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   }

//   const handleSave = () => {
//     if (!validate()) return;

//     onSave({
//       ...form,
//       loanDate: initialData ? form.loanDate : null,
//       loanAmount: parseCurrency(form.loanAmount),
//       // A new loan starts active; an edited loan keeps its current state.
//       isActive: initialData ? form.isActive : false,
//     });
//   };

//   const loanAmount = parseCurrency(form.loanAmount);
//   const interestRate = Number(form.interestRate || 0);
//   const installments = Number(form.noOfInstallments || 0);

//   const loanAmountMissing = loanAmount <= 0;
//   const interestRateInvalid = interestRate < 0;
//   const installmentsInvalid = installments <= 0;

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="md"
//       fullWidth
//     >
//       <DialogTitle className="!px-6 !pt-5 !pb-3">
//         <span className="text-[21px] font-medium text-surface-900">
//           {initialData ? "Update Loan" : "New Loan"}
//         </span>
//       </DialogTitle>

//       <DialogContent className="!px-6 !py-5">
//         <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">

//           {/* Employee */}
//           {/* OLD native select (kept for reference):
//           <SelectInput
//             label="Employee"
//             value={form.employeeId}
//             error={errors.employeeId}
//             onChange={handleChange("employeeId")}
//           >
//             <option value="">
//               Select Employee
//             </option>

//             {employees.map((emp) => (
//               <option
//                 key={emp.HED_EMPLOYEE_ID}
//                 value={emp.HED_EMPLOYEE_ID}
//               >
//                 {emp.HED_REPORT_NAME || "-"} ({emp.HED_SERVICE_NO})
//               </option>
//             ))}
//           </SelectInput>
//           */}
//           <Field label="Employee" error={errors.employeeId}>
//             {/* Search matches service no or name. */}
//             <SearchableSelect
//               value={form.employeeId}
//               // handleChange reads e.target.value, so hand it the same shape.
//               onChange={(v) => handleChange("employeeId")({ target: { value: v } })}
//               options={employees.map((emp) => ({
//                 value: String(emp.HED_EMPLOYEE_ID),
//                 label: `${emp.HED_SERVICE_NO ?? ""} - ${emp.HED_REPORT_NAME || "-"}`,
//               }))}
//               emptyOption={{ value: "", label: "Select Employee" }}
//               placeholder="Select Employee"
//               searchPlaceholder="Search by service no or name..."
//               className={`${inputClass} cursor-pointer ${errors.employeeId ? errorClass : ""}`}
//             />
//           </Field>

//           {/* Loan Number */}
//           <TextInput
//             label="Loan Number"
//             value={initialData ? form.loanNo : nextLoanNo}
//             readOnly
//             helperText={
//               initialData ? "Loan number cannot be changed." : "Automatically generated."
//             }
//           />

//           {/* Loan Type */}
//           <Field label="Loan Type" error={errors.loanType}>
//             <SearchableSelect
//               value={form.loanType}
//               onChange={(v) => handleChange("loanType")({ target: { value: v } })}
//               options={loanTypes}
//               emptyOption={{ value: "", label: "Select Loan Type" }}
//               placeholder="Select Loan Type"
//               searchPlaceholder="Search loan type..."
//               className={`${inputClass} cursor-pointer ${errors.loanType ? errorClass : ""}`}
//             />
//           </Field>

//           {/* Loan Date */}
//           {/* <DateInput
//             label="Loan Date"
//             value={form.loanDate}
//             error={errors.loanDate}
//             onChange={handleChange("loanDate")}
//           /> */}

//           {/* Start Payroll Period */}
//           <Field label="Start Payroll Period" error={errors.startPeriodId}>
//             <SearchableSelect
//               value={form.startPeriodId}
//               onChange={(v) => handleChange("startPeriodId")({ target: { value: v } })}
//               options={payrollPeriods
//                 // Active periods — plus, when editing, the loan's own period even
//                 // if it has since become inactive, so it still shows.
//                 .filter((period) => period.status === "Active" ||
//                   (initialData && String(period.id) === String(form.startPeriodId)))
//                 .map((period) => ({ value: period.id, label: `${period.code} - ${period.name}` }))}
//               emptyOption={{ value: "", label: "Select Payroll Period" }}
//               placeholder="Select Payroll Period"
//               searchPlaceholder="Search payroll period..."
//               className={`${inputClass} cursor-pointer ${errors.startPeriodId ? errorClass : ""}`}
//             />
//           </Field>

//           {/* Loan Description */}
//           <div className="sm:col-span-2">
//             <TextAreaInput
//               label="Loan Description"
//               value={form.loanDescription}
//               error={errors.loanDescription}
//               onChange={handleChange("loanDescription")}
//               rows={1}
//             />
//           </div>

//           {/* Loan Amount */}
//           <CurrencyInput
//             label="Loan Amount"
//             value={form.loanAmount}
//             error={errors.loanAmount}
//             onChange={handleChange("loanAmount")}
//           />

//           {/* Interest Rate */}
//           <TextInput
//             label="Annual Interest Rate (%)"
//             type="number"
//             value={form.interestRate}
//             error={errors.interestRate}
//             onChange={handleChange("interestRate")}
//           />

//           {/* Number of Installments */}
//           <TextInput
//             label="No. of Installments"
//             type="number"
//             value={form.noOfInstallments}
//             error={errors.noOfInstallments}
//             onChange={handleChange("noOfInstallments")}
//             helperText={
//               initialData ? "Changing this updates the loan only — existing installment rows are not rebuilt."
//               : undefined
//             }
//           />

//           {/* Installment Due Date */}
//           {!initialData && (
//             <DateInput
//               label="First Installment Due Date"
//               value={form.dueDate}
//               error={errors.dueDate}
//               onChange={handleChange("dueDate")}
//             />
//           )}

//           {/* Total Interest */}
//           <CurrencyInput
//             label="Total Interest"
//             value={form.totalInterest}
//             readOnly
//             helperText="Total Repayment − Loan Amount"
//           />

//           {/* Total Amount */}
//           <CurrencyInput
//             label="Total Amount"
//             value={form.totalAmount}
//             readOnly
//             helperText="Installment Amount × No. of Installments"
//           />

//           {/* Installment Amount */}
//           <CurrencyInput
//             label="Installment Amount"
//             value={form.installmentAmount}
//             readOnly
//             helperText="Standard reducing balance EMI"
//           />

//           {/* Balance Amount */}
//           <CurrencyInput
//             label="Balance Amount"
//             value={form.balanceAmount}
//             readOnly
//             helperText="Initial outstanding loan balance"
//           />

//           {/* Remarks */}
//           <div className="sm:col-span-2">
//             <TextAreaInput
//               label="Remarks"
//               value={form.remarks}
//               onChange={handleChange("remarks")}
//               rows={2}
//             />
//           </div>

//           {/* Calculation Info */}
//           {loanAmount > 0 &&
//             interestRate >= 0 &&
//             installments > 0 && (
//               <div className="sm:col-span-2">
//                 <div className="rounded-lg bg-[#F0F7F0] p-3">
//                   <p className="text-[12px] text-[#1B5C20]">
//                     Loan summary: Total loan amount is{" "}
//                     <strong>{form.totalAmount || 0}</strong>,
//                     payable in{" "}
//                     <strong>{installments}</strong>{" "}
//                     installments of{" "}
//                     <strong>{form.installmentAmount || 0}</strong>.
//                   </p>
//                 </div>
//               </div>
//             )}
//         </div>
//       </DialogContent>

//       <DialogActions className="!px-6 !py-3">
//         <Button
//           onClick={onClose}
//           className="!text-primary-600"
//         >
//           CANCEL
//         </Button>

//         <Button
//           variant="contained"
//           onClick={handleSave}
//           disabled={
//             loading ||
//             !form.employeeId ||
//             !form.loanType ||
//             loanAmountMissing ||
//             interestRateInvalid ||
//             installmentsInvalid 
//             // !form.startPeriodId ||
//             // !form.dueDate
//           }
//           className="!bg-primary-600 hover:!bg-primary-700"
//         >
//           {loading ? "SAVING..." : "SAVE"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }


// --------------------------------------------------------------------------------------
// VERSION 2
// --------------------------------------------------------------------------------------
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Pencil,
  Plus,
  Trash2,
  X,
  Loader2,
  FileText,
  Eye,
  Upload,
  Download,
} from "lucide-react";
import IsoDateInput from "../common/Isodateinput";
import SearchableSelect from "../common/SearchableSelect";
import { StatusPill } from "../Table/Table";
import toIsoDate from "../../utils/dateFormat";
import { fmtMoney } from "../../utils/payrollFormat";
import {
  fetchSuretiesByLoan,
  addSurety,
  updateSurety,
  deleteSurety,
  fetchLoanDocs,
  deleteLoanDoc,
  clearLoanDetails,
  fetchAllLoanTypes,
} from "../../store/slices/loanDetailsSlice";
import loanDetailsService from "../../services/LoanDetailsService";
import useToast from "../../utils/useToast";
import Toast from "../Toast/Toast";

/* ────────────────────────────────────────────────────────────────────────── */
/* Constants                                                                  */
/* ────────────────────────────────────────────────────────────────────────── */

const LOAN_TYPES = [
  { value: "Personal", label: "Personal" },
  { value: "Housing", label: "Housing" },
  { value: "Vehicle", label: "Vehicle" },
  { value: "Emergency", label: "Emergency" },
  { value: "Education", label: "Education" },
  { value: "Other", label: "Other" },
];

const SURETY_TYPES = [
  { value: "S", label: "Surety" },
  { value: "C", label: "Co-Surety" },
  { value: "G", label: "Guarantor" },
];

const DOC_TYPES = [
  { value: "Agreement", label: "Loan Agreement" },
  { value: "PromissoryNote", label: "Promissory Note" },
  { value: "GuarantorLetter", label: "Guarantor Letter" },
  { value: "SalarySlip", label: "Salary Slip / Proof" },
  { value: "Other", label: "Other Document" },
];

const LOAN_CATEGORIES = [
  { value: "M", label: "Loan" },
  { value: "O", label: "Other Loan" },
]

const INITIAL_FORM = {
  employeeId: "",
  loanNo: "",
  loanCategory: "M",    // 'M' or 'O'
  loanTypeId: "",
  loanType: "",
  dueDate: "",
  loanDescription: "",
  loanDate: null,
  loanAmount: "",
  interestRate: "",
  totalInterest: "",
  totalAmount: "",
  noOfInstallments: "",
  installmentAmount: "",
  startPeriodId: "",
  balanceAmount: "",
  status: "P",
  remarks: "",
};

const INITIAL_SURETY_FORM = {
  employeeId: "",
  type: "S",
  date: toIsoDate(new Date()),
  remarks: "",
};

/* ────────────────────────────────────────────────────────────────────────── */
/* Styles                                                                     */
/* ────────────────────────────────────────────────────────────────────────── */

const INPUT_CLASS = `
  w-full h-10
  rounded-lg
  border border-surface-200
  bg-surface-50/60
  px-3
  text-sm text-surface-800
  outline-none
  transition-all
  focus:bg-white
  focus:border-primary-500
  focus:ring-2 focus:ring-primary-500/10
`;

const DISABLED_INPUT_CLASS = `
  bg-gray-100
  text-gray-400
  border-gray-200
  opacity-60
  cursor-not-allowed
`;

const LABEL_CLASS = `
  absolute
  left-2.5
  top-0
  -translate-y-1/2
  bg-white
  px-1.5
  text-[11px]
  font-medium
  text-surface-500
  pointer-events-none
  z-10
`;

const SECTION_TITLE_CLASS = "text-sm font-semibold text-surface-900";
const SECTION_SUBTITLE_CLASS = "mt-0.5 text-xs text-surface-500";

/* ────────────────────────────────────────────────────────────────────────── */
/* Small Components                                                           */
/* ────────────────────────────────────────────────────────────────────────── */

function Field({ label, children, className = "", error = "" }) {
  return (
    <div className={`relative ${className}`}>
      <label className={LABEL_CLASS}>{label}</label>
      {children}
      {error && (
        <p className="mt-1 flex items-start gap-1 text-[11px] text-red-500">
          {error}
        </p>
      )}
    </div>
  );
}

function TextInput({
  label,
  value,
  min,
  onChange,
  type = "text",
  disabled = false,
  readOnly = false,
  helperText,
  error = "",
}) {
  return (
    <div>
      <Field label={label} error={error}>
        <input
          type={type}
          min={min}
          value={value ?? ""}
          onChange={onChange}
          disabled={disabled}
          readOnly={readOnly}
          className={`${INPUT_CLASS} ${
            disabled || readOnly ? DISABLED_INPUT_CLASS : ""
          } ${error ? "!border-red-400 focus:!border-red-500" : ""}`}
        />
      </Field>
      {helperText && (
        <p className="mt-1 px-1 text-[11px] text-surface-400">{helperText}</p>
      )}
    </div>
  );
}

function CurrencyInput({
  label,
  value,
  onChange,
  disabled = false,
  readOnly = false,
  helperText,
  error = "",
}) {
  const mask = (raw) => {
    const d = String(raw ?? "").replace(/\D/g, "");
    if (!d) return "";
    const p = d.padStart(3, "0");
    const c = p.slice(-2);
    const w = Number(p.slice(0, -2).replace(/^0+(?=\d)/, "") || "0").toLocaleString("en-US");
    return `${w}.${c}`;
  };

  let displayValue = value ?? "";
  if (readOnly && displayValue !== "") {
    const num = Number(displayValue);
    if (!Number.isNaN(num)) {
      displayValue = num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  }

  return (
    <div>
      <Field label={label} error={error}>
        <input
          type="text"
          inputMode="numeric"
          value={displayValue}
          disabled={disabled}
          readOnly={readOnly}
          onChange={(e) => !readOnly && onChange?.(mask(e.target.value))}
          className={`${INPUT_CLASS} ${
            disabled || readOnly ? DISABLED_INPUT_CLASS : ""
          } ${error ? "!border-red-400 focus:!border-red-500" : ""}`}
        />
      </Field>
      {helperText && (
        <p className="mt-1 px-1 text-[11px] text-surface-400">{helperText}</p>
      )}
    </div>
  );
}

function DateInput({ label, value, onChange, disabled = false, error = "" }) {
  return (
    <Field label={label} error={error}>
      <IsoDateInput
        value={value ?? ""}
        onChange={(val) => onChange?.(val)}
        disabled={disabled}
        className={`${INPUT_CLASS} appearance-none ${
          disabled ? DISABLED_INPUT_CLASS : ""
        } ${error ? "!border-red-400 focus:!border-red-500" : ""}`}
      />
    </Field>
  );
}

function TextArea({
  label,
  value,
  onChange,
  disabled = false,
  rows = 1,
  className = "",
  error = "",
}) {
  return (
    <Field label={label} error={error} className={className}>
      <textarea
        value={value ?? ""}
        onChange={onChange}
        disabled={disabled}
        rows={rows}
        className={`w-full rounded-lg border border-surface-200 bg-surface-50/60 px-3 py-2 text-sm text-surface-800 outline-none transition-all resize-none focus:bg-white focus:border-primary-500 focus:ring-2 focus:ring-primary-500/10 ${
          disabled ? DISABLED_INPUT_CLASS : ""
        } ${error ? "!border-red-400 focus:!border-red-500" : ""}`}
      />
    </Field>
  );
}

const parseCurrency = (val) => {
  if (val === "" || val == null) return 0;
  const n = Number(String(val).replace(/,/g, ""));
  return Number.isNaN(n) ? 0 : n;
};

/* ────────────────────────────────────────────────────────────────────────── */
/* Main Dialog Component                                                      */
/* ────────────────────────────────────────────────────────────────────────── */

export default function AddLoanDialog({
  open,
  onClose,
  onSave,
  loading = false,
  employees = [],
  payrollPeriods = [],
  initialData = null,
  nextLoanNo = "",
  mode = "add",
}) {
  const isAdd = mode === "add" && !initialData;
  const isView = mode === "view";
  const isEdit = mode === "edit" || (!!initialData && !isView);

  const dispatch = useDispatch();
  const { toast, showToast, hideToast } = useToast();

  const {
    sureties = [],
    loadingSureties = false,
    loanTypes = [],
    loadingLoanTypes = false,
  } = useSelector((state) => state.loanDetails || {});

  const [activeTab, setActiveTab] = useState(0);
  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState({});

  // Sureties local state
  const [suretyForm, setSuretyForm] = useState(INITIAL_SURETY_FORM);
  const [showSuretyForm, setShowSuretyForm] = useState(false);
  const [editingSuretyId, setEditingSuretyId] = useState(null);
  const [editingPendingSuretyIndex, setEditingPendingSuretyIndex] = useState(null);
  const [pendingSureties, setPendingSureties] = useState([]);
  const [suretyErrors, setSuretyErrors] = useState({});

  // Attachments local state
  const [attachments, setAttachments] = useState([]);
  const [pendingDocs, setPendingDocs] = useState([]);
  const [selectedDocType, setSelectedDocType] = useState("Agreement");
  const [selectedFile, setSelectedFile] = useState(null);
  const [downloadingDocType, setDownloadingDocType] = useState(null);
  const fileInputRef = useRef(null);

  const original = useRef({ amount: 0, balance: 0 });

  const currentLoanNo = initialData ? form.loanNo : nextLoanNo;

  const resetAll = useCallback(() => {
    setForm(INITIAL_FORM);
    setErrors({});
    setActiveTab(0);
    setSuretyForm(INITIAL_SURETY_FORM);
    setShowSuretyForm(false);
    setEditingSuretyId(null);
    setEditingPendingSuretyIndex(null);
    setPendingSureties([]);
    setSuretyErrors({});
    setAttachments([]);
    setPendingDocs([]);
    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
    dispatch(clearLoanDetails());
  }, [dispatch]);

  /* Load loan types */
  useEffect(() => {
    if (open && loanTypes.length === 0 && !loadingLoanTypes) {
      dispatch(fetchAllLoanTypes());
    }
  }, [open, dispatch, loanTypes.length, loadingLoanTypes])

  /* Load loan data */
  useEffect(() => {
    if (!open) {
      resetAll();
      return;
    }

    if (initialData) {
      const rawTypeId = initialData.loanTypeId || initialData.HLM_LOAN_TYPE_ID;
      const typeIdStr = rawTypeId ? String(rawTypeId) : "";

      const matchedType = loanTypes.find(
        (lt) =>
          (typeIdStr && String(lt.id) === typeIdStr) ||
          (initialData.loanType && lt.typeName?.toLowerCase() === initialData.loanType?.toLowerCase())
      );

      const resolvedCategory =
        initialData.loanCategoryCode ||
        matchedType?.categoryCode ||
        (initialData.loanType === "Other" ? "O" : "M");

      const resolvedTypeId = typeIdStr || (matchedType ? String(matchedType.id) : "");
      const resolvedTypeName = matchedType ? matchedType.typeName : (initialData.loanType || "");

      setForm({
        id: initialData.id,
        employeeId: initialData.employeeId || "",
        loanNo: initialData.loanNo || "",
        loanCategory: resolvedCategory,
        loanTypeId: resolvedTypeId,
        loanType: resolvedTypeName,
        loanDescription: initialData.loanDescription || "",
        loanDate: initialData.loanDate ? toIsoDate(initialData.loanDate) : "",
        loanAmount:
          initialData.amount != null
            ? Number(initialData.amount).toLocaleString("en-US", {
                minimumFractionDigits: 2,
              })
            : "",
        interestRate: initialData.interestRate ?? "",
        totalInterest: initialData.totalInterest ?? "",
        totalAmount: initialData.totalAmount ?? "",
        noOfInstallments: initialData.installments ?? "",
        installmentAmount: initialData.installmentAmount ?? "",
        startPeriodId: initialData.startPeriodId || "",
        balanceAmount: initialData.balance ?? "",
        remarks: initialData.remarks || "",
        approvedBy: initialData.approvedBy || "",
        approvedDate: initialData.approvedDate || "",
        status: initialData.statusCode || initialData.status || "P",
        isActive: initialData.isActive !== false,
      });

      original.current = {
        amount: Number(initialData.amount || 0),
        balance: Number(initialData.balance ?? initialData.amount ?? 0),
      };

      if (initialData.loanNo) {
        dispatch(fetchSuretiesByLoan(initialData.loanNo));
        loanDetailsService
          .ListLoanDocs(initialData.loanNo)
          .then((res) => setAttachments(res.data?.ResultSet || res.data || []))
          .catch(() => setAttachments([]));
      }
    } else {
      setForm({
        ...INITIAL_FORM,
        loanNo: nextLoanNo,
      });
    }
  }, [open, initialData, loanTypes, nextLoanNo, resetAll, dispatch]);

  const filteredLoanTypes = useMemo(() => {
    return loanTypes
      .filter((lt) => lt.isActive && lt.categoryCode === (form.loanCategory || "M"))
      .map((lt) => ({ value: String(lt.id), label: lt.typeName }));
  }, [loanTypes, form.loanCategory]);

  /* EMI Calculation */
  useEffect(() => {
    const amount = parseCurrency(form.loanAmount);
    const rate = Number(form.interestRate || 0);
    const installments = Number(form.noOfInstallments || 0);

    if (amount <= 0 || installments <= 0) {
      setForm((prev) => ({
        ...prev,
        totalInterest: 0,
        totalAmount: amount,
        installmentAmount: "",
        balanceAmount: amount,
      }));
      return;
    }

    const monthlyRate = rate / 12 / 100;
    let installmentAmount = 0;

    if (monthlyRate === 0) {
      installmentAmount = Math.round((amount / installments) * 100) / 100;
    } else {
      const factor = Math.pow(1 + monthlyRate, installments);
      const emi = (amount * monthlyRate * factor) / (factor - 1);
      installmentAmount = Math.round(emi * 100) / 100;
    }

    const totalAmount = Math.round(installmentAmount * installments * 100) / 100;
    const totalInterest = Math.max(0, Math.round((totalAmount - amount) * 100) / 100);
    const balanceAmount = initialData
      ? Math.max(
          0,
          Math.round(
            (original.current.balance + (amount - original.current.amount)) * 100
          ) / 100
        )
      : amount;

    setForm((prev) => ({
      ...prev,
      totalInterest,
      totalAmount,
      installmentAmount,
      balanceAmount,
    }));
  }, [form.loanAmount, form.interestRate, form.noOfInstallments, initialData]);

  const handleFieldChange = (key, value) => {
    if (isView) return;
    setForm((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  /* ── Surety Handlers ───────────────────────────────────────────────────── */
  const handleAddOrUpdateSurety = async () => {
    const vErrors = {};
    if (!suretyForm.employeeId) {
      vErrors.employeeId = "Please select a guarantor employee.";
    }
    if (String(suretyForm.employeeId) === String(form.employeeId)) {
      vErrors.employeeId = "Guarantor cannot be the borrower.";
    }

    if (Object.keys(vErrors).length > 0) {
      setSuretyErrors(vErrors);
      return;
    }

    // Editing a saved surety in DB
    if (editingSuretyId) {
      try {
        await dispatch(
          updateSurety({
            suretyId: editingSuretyId,
            employeeId: suretyForm.employeeId,
            type: suretyForm.type,
            remarks: suretyForm.remarks,
            date: suretyForm.date,
          })
        ).unwrap();
        showToast("Guarantor updated successfully.", "success");
        dispatch(fetchSuretiesByLoan(currentLoanNo));
        resetSuretySubForm();
      } catch (e) {
        showToast(e || "Failed to update guarantor.", "error");
      }
      return;
    }

    // If loan is already in DB, save surety directly
    if (initialData?.loanNo) {
      try {
        await dispatch(
          addSurety({
            loanNo: currentLoanNo,
            employeeId: suretyForm.employeeId,
            year: new Date().getFullYear(),
            type: suretyForm.type,
            remarks: suretyForm.remarks,
            date: suretyForm.date,
          })
        ).unwrap();
        showToast("Guarantor added successfully.", "success");
        dispatch(fetchSuretiesByLoan(currentLoanNo));
        resetSuretySubForm();
      } catch (e) {
        showToast(e || "Failed to add guarantor.", "error");
      }
      return;
    }

    // New Loan staging mode
    const item = { ...suretyForm };
    if (editingPendingSuretyIndex !== null) {
      setPendingSureties((prev) =>
        prev.map((s, idx) => (idx === editingPendingSuretyIndex ? item : s))
      );
    } else {
      setPendingSureties((prev) => [...prev, item]);
    }
    resetSuretySubForm();
  };

  const resetSuretySubForm = () => {
    setSuretyForm(INITIAL_SURETY_FORM);
    setEditingSuretyId(null);
    setEditingPendingSuretyIndex(null);
    setShowSuretyForm(false);
    setSuretyErrors({});
  };

  const handleDeleteSurety = async (suretyId, index) => {
    if (suretyId) {
      try {
        await dispatch(deleteSurety(suretyId)).unwrap();
        showToast("Guarantor removed successfully.", "success");
        dispatch(fetchSuretiesByLoan(currentLoanNo));
      } catch (e) {
        showToast(e || "Failed to remove guarantor.", "error");
      }
    } else {
      setPendingSureties((prev) => prev.filter((_, idx) => idx !== index));
    }
  };

  /* ── Staging Documents Locally ─────────────────────────────────────────── */
  const handleStageDoc = () => {
    if (!selectedFile) {
      showToast("Please select a file to attach.", "error");
      return;
    }

    // Check if docType already exists in server attachments or pending list
    const alreadySaved = attachments.some(
      (d) => (d.DocType || d.HCL_DOC_TYPE || d.docType) === selectedDocType
    );
    const alreadyPending = pendingDocs.some((d) => d.docType === selectedDocType);

    if (alreadySaved || alreadyPending) {
      showToast(`A document with type "${selectedDocType}" is already attached.`, "error");
      return;
    }

    setPendingDocs((prev) => [
      ...prev,
      {
        docType: selectedDocType,
        file: selectedFile,
        fileName: selectedFile.name,
        fileSize: (selectedFile.size / 1024).toFixed(1) + " KB",
      },
    ]);

    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
    showToast("Document staged for upload.", "success");
  };

  const handleRemovePendingDoc = (docType) => {
    setPendingDocs((prev) => prev.filter((d) => d.docType !== docType));
  };

  const handleDeleteSavedDoc = async (docType) => {
    try {
      await loanDetailsService.DeleteLoanDoc(currentLoanNo, docType);
      showToast("Document deleted successfully.", "success");
      const res = await loanDetailsService.ListLoanDocs(currentLoanNo);
      setAttachments(res.data?.ResultSet || res.data || []);
    } catch (e) {
      showToast(e?.response?.data?.Message || "Failed to delete document.", "error");
    }
  };

  const handleDownloadDoc = async (docType, fileName) => {
    setDownloadingDocType(docType);
    try {
      const response = await loanDetailsService.DownloadLoanDoc(currentLoanNo, docType);
      
      // Determine file extension/content type
      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);

      // Trigger standard browser download
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || `${currentLoanNo}_${docType}`;
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Failed to download document:", e);
      showToast(e?.response?.data?.Message || "Failed to download document.", "error");
    } finally {
      setDownloadingDocType(null);
    }
  };

  /* ── Save Loan ─────────────────────────────────────────────────────────── */
  const validate = () => {
    const vErrors = {};
    if (!form.employeeId) vErrors.employeeId = "Employee is required.";
    if (!form.loanTypeId) vErrors.loanTypeId = "Loan type is required.";

    // if (!form.loanType) vErrors.loanType = "Loan type is required.";
    const amt = parseCurrency(form.loanAmount);
    if (amt <= 0) vErrors.loanAmount = "Loan amount must be greater than 0.";

    const rate = Number(form.interestRate);
    if (form.interestRate === "" || Number.isNaN(rate) || rate < 0) {
      vErrors.interestRate = "Interest rate cannot be negative.";
    }
    const inst = Number(form.noOfInstallments);
    if (form.noOfInstallments === "" || Number.isNaN(inst) || inst <= 0) {
      vErrors.noOfInstallments = "Installments must be greater than 0.";
    }
    if (!form.startPeriodId) vErrors.startPeriodId = "Payroll period is required.";
    if (!initialData && !form.dueDate) {
      vErrors.dueDate = "First installment due date is required.";
    }

    setErrors(vErrors);
    return Object.keys(vErrors).length === 0;
  };

  const handleSave = async () => {
    if (isView) {
      onClose();
      return;
    }
    if (!validate()) return;

    const isOtherLoan = form.loanCategory === "O";
    const today = new Date().toISOString().split("T")[0];

    await onSave?.({
      ...form,
      interestRate: isOtherLoan ? 0 : Number(form.interestRate || 0),
      loanDate: initialData ? form.loanDate : (isOtherLoan ? today : null),
      approvedDate: isOtherLoan ? today : (form.approvedDate || null),
      isActive: isOtherLoan ? true : (initialData ? form.isActive : false),
      status: isOtherLoan ? "P" : (form.status || "P"),
      loanAmount: parseCurrency(form.loanAmount),
      pendingSureties,
      pendingDocs,
    });
  };

  if (!open) return null;

  const selectedEmpObj = employees.find(
    (e) => String(e.HED_EMPLOYEE_ID) === String(form.employeeId)
  );

  const title = isAdd ? "New Staff Loan" : isView ? "Staff Loan Details" : "Update Staff Loan";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-surface-900/40 backdrop-blur-xs transition-opacity"
        onClick={loading ? undefined : onClose}
      />

      {/* Modal Container */}
      <div className="relative z-10 flex h-[88vh] max-h-[88vh] w-full max-w-4xl flex-col rounded-2xl bg-white shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5">
          <div>
            <h2 className="text-lg font-semibold text-surface-900">{title}</h2>
            {selectedEmpObj && (
              <p className="mt-0.5 text-xs text-surface-500">
                {selectedEmpObj.HED_SERVICE_NO} &bull; {selectedEmpObj.HED_REPORT_NAME} &bull; Loan No: {currentLoanNo}
              </p>
            )}
          </div>
          <button
            type="button"
            onClick={loading ? undefined : onClose}
            className="rounded-full p-2 text-surface-400 hover:bg-surface-100 hover:text-surface-700 transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        {/* Navigation Tabs */}
        <div className="px-8 border-b border-surface-100">
          <nav className="-mb-px flex space-x-7" aria-label="Tabs">
            <button
              type="button"
              onClick={() => setActiveTab(0)}
              className={`py-3 text-sm font-medium border-b-2 transition-all ${
                activeTab === 0
                  ? "border-primary-600 text-primary-600"
                  : "border-transparent text-surface-400 hover:text-surface-600"
              }`}
            >
              Loan & Attachments
            </button>
            <button
              type="button"
              onClick={() => setActiveTab(1)}
              className={`inline-flex items-center gap-2 py-3 text-sm font-medium border-b-2 transition-all ${
                activeTab === 1
                  ? "border-primary-600 text-primary-600"
                  : "border-transparent text-surface-400 hover:text-surface-600"
              }`}
            >
              <span>Surety / Guarantors</span>
              <span className="inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-primary-100 px-1 text-[10px] font-bold text-primary-800">
                {sureties.length + pendingSureties.length}
              </span>
            </button>
          </nav>
        </div>

        {/* Content Body */}
        <div className="flex-1 overflow-y-auto px-8 py-6">
          {/* TAB 0: Loan Details & Attachments */}
          {activeTab === 0 && (
            <div className="space-y-8">
              <section>
                <div className="mb-6">
                  <h3 className={SECTION_TITLE_CLASS}>Master Loan Details</h3>
                  <p className={SECTION_SUBTITLE_CLASS}>
                    Set borrowing terms, payback tenure, and calculate repayment schedules.
                  </p>
                </div>

                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                  {/* Employee */}
                  <Field label="Employee" error={errors.employeeId}>
                    <SearchableSelect
                      value={form.employeeId}
                      onChange={(v) => handleFieldChange("employeeId", v)}
                      options={employees.map((emp) => ({
                        value: String(emp.HED_EMPLOYEE_ID),
                        label: `${emp.HED_SERVICE_NO ?? ""} - ${emp.HED_REPORT_NAME ?? ""}`,
                      }))}
                      disabled={!isAdd || isView}
                      emptyOption={{ value: "", label: "Select Employee" }}
                      placeholder="Select Employee"
                      className={`${INPUT_CLASS} ${
                        !isAdd || isView ? DISABLED_INPUT_CLASS : "cursor-pointer"
                      }`}
                    />
                  </Field>

                  {/* Loan Number */}
                  <TextInput
                    label="Loan Number"
                    value={currentLoanNo}
                    readOnly
                    helperText={isAdd ? "Automatically generated" : "Assigned number"}
                  />

                  {/* Loan Type */}
                  {/* <Field label="Loan Type" error={errors.loanType}>
                    <SearchableSelect
                      value={form.loanType}
                      onChange={(v) => handleFieldChange("loanType", v)}
                      options={LOAN_TYPES}
                      disabled={isView}
                      emptyOption={{ value: "", label: "Select Loan Type" }}
                      placeholder="Select Loan Type"
                      className={`${INPUT_CLASS} ${isView ? DISABLED_INPUT_CLASS : "cursor-pointer"}`}
                    />
                  </Field> */}

                  {/* Loan Category ('M' | 'O') */}
                  <Field label="Category">
                    <select
                      value={form.loanCategory}
                      disabled={isView}
                      onChange={(e) => {
                        const cat = e.target.value;
                        setForm((prev) => ({
                          ...prev,
                          loanCategory: cat,
                          loanTypeId: "",
                          loanType: "",
                          // "Other Loans" have 0 interest
                          interestRate: cat === "O" ? "0" : (prev.interestRate === "0" ? "" : prev.interestRate),
                        }));
                      }}
                      className={`${INPUT_CLASS} appearance-auto cursor-pointer ${
                        isView ? DISABLED_INPUT_CLASS : ""
                      }`}
                    >
                      {LOAN_CATEGORIES.map((c) => (
                        <option key={c.value} value={c.value}>
                          {c.label}
                        </option>
                      ))}
                    </select>
                  </Field>

                  {/* Loan Type (Filtered by Category) */}
                  <Field label="Loan Type" error={errors.loanTypeId}>
                    <SearchableSelect
                      value={form.loanTypeId}
                      onChange={(selectedId) => {
                        const matched = loanTypes.find((lt) => String(lt.id) === String(selectedId));
                        setForm((prev) => ({
                          ...prev,
                          loanTypeId: selectedId,
                          loanType: matched ? matched.typeName : "",
                        }));
                        setErrors((prev) => ({ ...prev, loanTypeId: "" }));
                      }}
                      options={filteredLoanTypes}
                      disabled={isView}
                      emptyOption={{ value: "", label: "Select Loan Type" }}
                      placeholder="Select Loan Type"
                      className={`${INPUT_CLASS} ${isView ? DISABLED_INPUT_CLASS : "cursor-pointer"}`}
                    />
                  </Field>

                  {/* Start Payroll Period */}
                  <Field label="Start Payroll Period" error={errors.startPeriodId}>
                    <SearchableSelect
                      value={form.startPeriodId}
                      onChange={(v) => handleFieldChange("startPeriodId", v)}
                      disabled={isView}
                      options={payrollPeriods
                        .filter(
                          (p) =>
                            p.status === "Active" ||
                            (initialData && String(p.id) === String(form.startPeriodId))
                        )
                        .map((p) => ({
                          value: p.id,
                          label: `${p.code} - ${p.name}`,
                        }))}
                      emptyOption={{ value: "", label: "Select Payroll Period" }}
                      placeholder="Select Payroll Period"
                      className={`${INPUT_CLASS} ${isView ? DISABLED_INPUT_CLASS : "cursor-pointer"}`}
                    />
                  </Field>

                  {/* Loan Amount */}
                  <CurrencyInput
                    label="Loan Amount (Rs)"
                    value={form.loanAmount}
                    error={errors.loanAmount}
                    disabled={isView}
                    onChange={(v) => handleFieldChange("loanAmount", v)}
                  />

                  {/* Annual Interest Rate */}
                  <TextInput
                    label="Annual Interest Rate (%)"
                    type="number"
                    value={form.loanCategory === "O" ? "0" : form.interestRate}
                    error={errors.interestRate}
                    disabled={isView || form.loanCategory === "O"}
                    helperText={form.loanCategory === "O" ? "Interest-free for Other Loans" : undefined}
                    onChange={(e) => handleFieldChange("interestRate", e.target.value)}
                  />

                  {/* No. of Installments */}
                  <TextInput
                    label="No. of Installments"
                    type="number"
                    value={form.noOfInstallments}
                    min={0}
                    error={errors.noOfInstallments}
                    disabled={isView}
                    onChange={(e) => handleFieldChange("noOfInstallments", e.target.value)}
                  />

                  {/* First Due Date */}
                  {!initialData && (
                    <DateInput
                      label="First Due Date"
                      value={form.dueDate}
                      error={errors.dueDate}
                      disabled={isView}
                      onChange={(v) => handleFieldChange("dueDate", v)}
                    />
                  )}

                  {/* Computed Installment Amount */}
                  <CurrencyInput
                    label="Monthly Installment Amount"
                    value={form.installmentAmount}
                    readOnly
                    helperText="Calculated reducing EMI"
                  />

                  {/* Computed Total Interest */}
                  <CurrencyInput
                    label="Total Interest (Rs)"
                    value={form.totalInterest}
                    readOnly
                    helperText="Total Interest over lifetime"
                  />

                  {/* Computed Total Amount */}
                  <CurrencyInput
                    label="Total Repayable Amount"
                    value={form.totalAmount}
                    readOnly
                    helperText="Principal + Interest"
                  />

                  {/* Current Balance */}
                  <CurrencyInput
                    label="Remaining Balance"
                    value={form.balanceAmount}
                    readOnly
                    helperText="Current outstanding balance"
                  />

                  {/* Description */}
                  <TextArea
                    label="Loan Description"
                    value={form.loanDescription}
                    error={errors.loanDescription}
                    disabled={isView}
                    rows={1}
                    className="sm:col-span-2"
                    onChange={(e) => handleFieldChange("loanDescription", e.target.value)}
                  />

                  {/* Remarks */}
                  <TextArea
                    label="Remarks"
                    value={form.remarks}
                    disabled={isView}
                    rows={1}
                    className="sm:col-span-2"
                    onChange={(e) => handleFieldChange("remarks", e.target.value)}
                  />
                </div>
              </section>

              {/* Attachments Section */}
              <section className="pt-2 border-t border-surface-100">
                <div className="mb-4 flex items-center justify-between">
                  <div>
                    <h3 className={SECTION_TITLE_CLASS}>Loan Documents & Attachments</h3>
                    <p className={SECTION_SUBTITLE_CLASS}>
                      Attach scanned promissory notes, agreement letters, and approvals (uploaded upon saving).
                    </p>
                  </div>
                </div>

                {!isView && (
                  <div className="mb-4 flex flex-wrap items-end gap-3 rounded-xl bg-surface-50 p-4 border border-surface-200/60">
                    <div className="w-56">
                      <span className="block text-xs font-medium text-surface-600 mb-1">
                        Document Type
                      </span>
                      <select
                        value={selectedDocType}
                        onChange={(e) => setSelectedDocType(e.target.value)}
                        className={`${INPUT_CLASS} appearance-auto`}
                      >
                        {DOC_TYPES.map((dt) => (
                          <option key={dt.value} value={dt.value}>
                            {dt.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="flex-1 min-w-[200px]">
                      <span className="block text-xs font-medium text-surface-600 mb-1">
                        Select File
                      </span>
                      <input
                        ref={fileInputRef}
                        type="file"
                        onChange={(e) => setSelectedFile(e.target.files?.[0] || null)}
                        className="text-xs text-surface-600 file:mr-2 file:py-1.5 file:px-3 file:rounded-md file:border-0 file:text-xs file:font-medium file:bg-surface-200 file:text-surface-700 hover:file:bg-surface-300 cursor-pointer"
                      />
                    </div>

                    <button
                      type="button"
                      onClick={handleStageDoc}
                      disabled={!selectedFile}
                      className="inline-flex items-center gap-1.5 rounded-lg bg-primary-600 px-4 py-2 text-xs font-medium text-white shadow-xs hover:bg-primary-700 disabled:opacity-50"
                    >
                      <Plus size={14} />
                      Attach Document
                    </button>
                  </div>
                )}

                {attachments.length === 0 && pendingDocs.length === 0 ? (
                  <div className="py-6 text-center text-xs text-surface-400">
                    No documents attached for this loan record.
                  </div>
                ) : (
                  <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                    {/* Saved attachments from server */}
                    {attachments.map((doc, idx) => {
                      const docType = doc.DocType || doc.HCL_DOC_TYPE || doc.docType || "Document";
                      return (
                        <div
                          key={`saved-${idx}`}
                          className="flex items-center justify-between rounded-lg border border-surface-200/80 bg-white p-3 hover:bg-surface-50/50"
                        >
                          <div className="flex items-center gap-2.5">
                            <FileText size={16} className="text-primary-600" />
                            <div>
                              <p className="text-xs font-medium text-surface-800">{docType}</p>
                              <span className="text-[10px] text-surface-400">
                                {doc.FileName || "Attached Document"}
                              </span>
                            </div>
                          </div>
                          <div className="flex items-center gap-1">
                            <button
                              type="button"
                              onClick={() => handleDownloadDoc(docType, doc.FileName)}
                              disabled={downloadingDocType === docType}
                              className="rounded p-1 text-surface-400 hover:bg-surface-100 hover:text-primary-600 disabled:opacity-50"
                              title="Download document"
                            >
                              {downloadingDocType === docType ? (
                                <Loader2 size={14} className="animate-spin text-primary-600" />
                              ) : (
                                <Download size={14} />
                              )}
                            </button>
                            {!isView && (
                              <button
                                type="button"
                                onClick={() => handleDeleteSavedDoc(docType)}
                                className="rounded p-1 text-surface-400 hover:bg-red-50 hover:text-red-500"
                                title="Delete"
                              >
                                <Trash2 size={14} />
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    {/* Pending staged attachments */}
                    {pendingDocs.map((doc, idx) => (
                      <div
                        key={`pending-${idx}`}
                        className="flex items-center justify-between rounded-lg border border-primary-200 bg-primary-50/30 p-3"
                      >
                        <div className="flex items-center gap-2.5">
                          <FileText size={16} className="text-primary-700" />
                          <div>
                            <div className="flex items-center gap-1.5">
                              <p className="text-xs font-medium text-surface-800">{doc.docType}</p>
                              <span className="rounded bg-primary-100 px-1.5 py-0.2 text-[9px] font-semibold text-primary-700">
                                Pending Save
                              </span>
                            </div>
                            <span className="text-[10px] text-surface-500">
                              {doc.fileName} ({doc.fileSize})
                            </span>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => handleRemovePendingDoc(doc.docType)}
                          className="rounded p-1 text-surface-400 hover:bg-red-50 hover:text-red-500"
                          title="Remove"
                        >
                          <Trash2 size={14} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </section>
            </div>
          )}

          {/* TAB 1: Surety Information */}
          {activeTab === 1 && (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className={SECTION_TITLE_CLASS}>Surety & Guarantor Details</h3>
                  <p className={SECTION_SUBTITLE_CLASS}>
                    Assign eligible employee co-signers and guarantors for this loan.
                  </p>
                </div>

                {!isView && (
                  <button
                    type="button"
                    onClick={() => {
                      setShowSuretyForm((prev) => !prev);
                      setEditingSuretyId(null);
                      setEditingPendingSuretyIndex(null);
                      setSuretyForm(INITIAL_SURETY_FORM);
                    }}
                    className="inline-flex items-center gap-1.5 rounded-lg border border-primary-600/30 bg-primary-50/50 px-3 py-1.5 text-xs font-semibold text-primary-700 transition-colors hover:bg-primary-100/60"
                  >
                    <Plus size={14} />
                    Add Guarantor
                  </button>
                )}
              </div>

              {/* Surety Form Modal/Drawer Inline */}
              {showSuretyForm && !isView && (
                <div className="rounded-xl bg-surface-50/80 p-5 ring-1 ring-surface-200/70 space-y-4">
                  <div className="flex items-center justify-between">
                    <h4 className="text-xs font-semibold text-surface-800">
                      {editingSuretyId || editingPendingSuretyIndex !== null
                        ? "Edit Guarantor Details"
                        : "New Guarantor"}
                    </h4>
                    <button
                      type="button"
                      onClick={resetSuretySubForm}
                      className="rounded-full p-1 text-surface-400 hover:bg-surface-200/50 hover:text-surface-700"
                    >
                      <X size={14} />
                    </button>
                  </div>

                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <Field label="Guarantor Employee" error={suretyErrors.employeeId}>
                      <SearchableSelect
                        value={suretyForm.employeeId}
                        onChange={(v) =>
                          setSuretyForm((prev) => ({ ...prev, employeeId: v }))
                        }
                        options={employees.map((emp) => ({
                          value: String(emp.HED_EMPLOYEE_ID),
                          label: `${emp.HED_SERVICE_NO ?? ""} - ${emp.HED_REPORT_NAME ?? ""}`,
                        }))}
                        emptyOption={{ value: "", label: "Select Guarantor" }}
                        placeholder="Select Guarantor"
                        className={`${INPUT_CLASS} cursor-pointer`}
                      />
                    </Field>

                    <Field label="Guarantor Role / Type">
                      <select
                        value={suretyForm.type}
                        onChange={(e) =>
                          setSuretyForm((prev) => ({ ...prev, type: e.target.value }))
                        }
                        className={`${INPUT_CLASS} appearance-auto`}
                      >
                        {SURETY_TYPES.map((st) => (
                          <option key={st.value} value={st.value}>
                            {st.label}
                          </option>
                        ))}
                      </select>
                    </Field>

                    <DateInput
                      label="Signing / Guarantee Date"
                      value={suretyForm.date}
                      onChange={(v) => setSuretyForm((prev) => ({ ...prev, date: v }))}
                    />

                    <TextArea
                      label="Remarks"
                      value={suretyForm.remarks}
                      rows={1}
                      onChange={(e) =>
                        setSuretyForm((prev) => ({ ...prev, remarks: e.target.value }))
                      }
                    />
                  </div>

                  <div className="flex justify-end gap-2 pt-2">
                    <button
                      type="button"
                      onClick={resetSuretySubForm}
                      className="rounded-lg px-3 py-1.5 text-xs font-medium text-surface-600 hover:bg-surface-200/50"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleAddOrUpdateSurety}
                      className="inline-flex items-center gap-1.5 rounded-lg bg-primary-600 px-4 py-1.5 text-xs font-medium text-white shadow-xs hover:bg-primary-700"
                    >
                      {editingSuretyId || editingPendingSuretyIndex !== null ? "Update" : "Add"}
                    </button>
                  </div>
                </div>
              )}

              {/* Sureties Table */}
              {loadingSureties ? (
                <div className="flex h-32 items-center justify-center">
                  <Loader2 className="animate-spin text-primary-600" size={20} />
                </div>
              ) : sureties.length === 0 && pendingSureties.length === 0 ? (
                <div className="py-12 text-center text-xs text-surface-400">
                  No guarantors or sureties registered for this loan.
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="border-b border-surface-100 text-surface-400">
                        <th className="pb-3 text-left font-medium">Guarantor</th>
                        <th className="pb-3 text-center font-medium">Type</th>
                        <th className="pb-3 text-center font-medium">Date</th>
                        <th className="pb-3 text-left font-medium">Remarks</th>
                        {!isView && (
                          <th className="w-20 pb-3 text-center font-medium">Actions</th>
                        )}
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-surface-100/60">
                      {/* Saved sureties from server */}
                      {sureties.map((s) => {
                        const emp = employees.find(
                          (e) => String(e.HED_EMPLOYEE_ID) === String(s.HSD_EMPLOYEE_ID)
                        );
                        const typeLabel =
                          SURETY_TYPES.find((t) => t.value === s.HSD_TYPE)?.label || s.HSD_TYPE;

                        return (
                          <tr key={s.HSD_ID} className="group hover:bg-surface-50/50">
                            <td className="py-3 font-medium text-surface-800">
                              {emp ? `${emp.HED_REPORT_NAME} (${emp.HED_SERVICE_NO})` : s.HSD_EMPLOYEE_ID}
                            </td>
                            <td className="py-3 text-center">
                              <span className="rounded bg-surface-100 px-2 py-0.5 text-[10px] font-semibold text-surface-700">
                                {typeLabel}
                              </span>
                            </td>
                            <td className="py-3 text-center text-surface-500">
                              {toIsoDate(s.HSD_DATE)}
                            </td>
                            <td className="py-3 text-surface-500 max-w-xs truncate">
                              {s.HSD_REMARKS || "-"}
                            </td>
                            {!isView && (
                              <td className="py-3 text-center">
                                <div className="flex items-center justify-center gap-1 opacity-80 group-hover:opacity-100">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setEditingSuretyId(s.HSD_ID);
                                      setSuretyForm({
                                        employeeId: s.HSD_EMPLOYEE_ID,
                                        type: s.HSD_TYPE,
                                        date: toIsoDate(s.HSD_DATE),
                                        remarks: s.HSD_REMARKS || "",
                                      });
                                      setShowSuretyForm(true);
                                    }}
                                    className="rounded p-1 text-surface-400 hover:bg-surface-100 hover:text-primary-600"
                                    title="Edit"
                                  >
                                    <Pencil size={13} />
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteSurety(s.HSD_ID)}
                                    className="rounded p-1 text-surface-400 hover:bg-red-50 hover:text-red-500"
                                    title="Delete"
                                  >
                                    <Trash2 size={13} />
                                  </button>
                                </div>
                              </td>
                            )}
                          </tr>
                        );
                      })}

                      {/* Staged sureties for unsaved loan */}
                      {pendingSureties.map((s, idx) => {
                        const emp = employees.find(
                          (e) => String(e.HED_EMPLOYEE_ID) === String(s.employeeId)
                        );
                        const typeLabel =
                          SURETY_TYPES.find((t) => t.value === s.type)?.label || s.type;

                        return (
                          <tr key={`pending-${idx}`} className="group bg-primary-50/20">
                            <td className="py-3 font-medium text-surface-800">
                              {emp ? `${emp.HED_REPORT_NAME} (${emp.HED_SERVICE_NO})` : s.employeeId}
                              <span className="ml-2 rounded-full bg-primary-100/70 px-2 py-0.5 text-[9px] font-semibold text-primary-700">
                                New
                              </span>
                            </td>
                            <td className="py-3 text-center">
                              <span className="rounded bg-primary-100 px-2 py-0.5 text-[10px] font-semibold text-primary-800">
                                {typeLabel}
                              </span>
                            </td>
                            <td className="py-3 text-center text-surface-500">
                              {toIsoDate(s.date)}
                            </td>
                            <td className="py-3 text-surface-500 max-w-xs truncate">
                              {s.remarks || "-"}
                            </td>
                            <td className="py-3 text-center">
                              <div className="flex items-center justify-center gap-1 opacity-80 group-hover:opacity-100">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setEditingPendingSuretyIndex(idx);
                                    setSuretyForm(s);
                                    setShowSuretyForm(true);
                                  }}
                                  className="rounded p-1 text-surface-400 hover:bg-surface-100 hover:text-primary-600"
                                  title="Edit"
                                >
                                  <Pencil size={13} />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleDeleteSurety(null, idx)}
                                  className="rounded p-1 text-surface-400 hover:bg-red-50 hover:text-red-500"
                                  title="Remove"
                                >
                                  <Trash2 size={13} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Footer Actions */}
        <div className="flex items-center justify-end gap-3 px-8 py-4 bg-surface-50/50">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="rounded-lg px-4 py-2 text-sm font-medium text-surface-600 hover:bg-surface-100 hover:text-surface-800 transition-colors disabled:opacity-50"
          >
            {isView ? "Close" : "Cancel"}
          </button>

          {!isView && (
            <button
              type="button"
              onClick={handleSave}
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-lg bg-primary-600 px-5 py-2 text-sm font-medium text-white shadow-xs hover:bg-primary-700 active:bg-primary-800 transition-colors disabled:opacity-50"
            >
              {loading && <Loader2 size={16} className="animate-spin" />}
              {loading ? "Saving..." : isEdit ? "Update" : "Save"}
            </button>
          )}
        </div>
      </div>

      <Toast message={toast?.message} type={toast?.type} onClose={hideToast} />
    </div>
  );
}